import React from 'react';
import {
    Table,
} from 'antd';
import { getCurrentShopId } from '../shop/get-current-shop';

const typeMap = {
    1: '发货',
    2: '退货'
}

const deliveryTypeMap = {
    express: '快递',
    self_pick: '自提',
    no_express: '无需物流'
}


const columns = [
    {
        title: '序号',
        render: (text, record, index) => `包裹${index + 1}`,
    },
    {
        title: '发货/退货',
        dataIndex: 'type',
        render: (text) => text === 2 ? <span className="text-red-500">{typeMap[text]}</span> : typeMap[text]
    },
    {
        title: '发货方式',
        dataIndex: 'deliveryType',
        render: (text) => deliveryTypeMap[text]
    },
    {
        title: '公司',
        dataIndex: 'company',
    },
    {
        fixed: 'right',
        title: '快递单号',
        dataIndex: 'number',
    }
]

export default ({parentOrderId}) => {
    const [list, setList] = React.useState([]);

    React.useEffect(() => {
        fetchLogistics();
    }, [parentOrderId]);

    const fetchLogistics = async () => {
        const shopId = await getCurrentShopId();
        const res = await fetch(`/api/logistics/list?parentOrderId=${parentOrderId}&shopId=${shopId}`);
        const result = await res.json();

        if(result?.success) {
            setList(result?.data?.rows);        
        }else {
            setList([]);
        }
    }
    return <Table rowKey={'id'} columns={columns} dataSource={list} size='small' scroll={{x: 'max-content'}} />
}